/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  ConflictErrorResponse,
  CreateUserContactRequest,
  GetApiUserContactList200,
  GetApiUserContactListParams,
  NotFoundErrorResponse,
  UnauthorizedErrorResponse,
  UserContactApiResource
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiUserContactListResponse200 = {
  data: GetApiUserContactList200
  status: 200
}

export type getApiUserContactListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiUserContactListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiUserContactListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiUserContactListResponseSuccess = (getApiUserContactListResponse200) & {
  headers: Headers;
};
export type getApiUserContactListResponseError = (getApiUserContactListResponse400 | getApiUserContactListResponse401 | getApiUserContactListResponse403) & {
  headers: Headers;
};

export type getApiUserContactListResponse = (getApiUserContactListResponseSuccess | getApiUserContactListResponseError)

export const getGetApiUserContactListUrl = (userId: string,
    params?: GetApiUserContactListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/users/${userId}/contacts?${stringifiedParams}` : `/api/users/${userId}/contacts`
}

export const getApiUserContactList = async (userId: string,
    params?: GetApiUserContactListParams, options?: RequestInit): Promise<getApiUserContactListResponse> => {
  
  return customFetch<getApiUserContactListResponse>(getGetApiUserContactListUrl(userId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiUserContactCreateResponse201 = {
  data: UserContactApiResource
  status: 201
}

export type postApiUserContactCreateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiUserContactCreateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiUserContactCreateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiUserContactCreateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type postApiUserContactCreateResponseSuccess = (postApiUserContactCreateResponse201) & {
  headers: Headers;
};
export type postApiUserContactCreateResponseError = (postApiUserContactCreateResponse400 | postApiUserContactCreateResponse401 | postApiUserContactCreateResponse403 | postApiUserContactCreateResponse409) & {
  headers: Headers;
};

export type postApiUserContactCreateResponse = (postApiUserContactCreateResponseSuccess | postApiUserContactCreateResponseError)

export const getPostApiUserContactCreateUrl = (userId: string,) => {


  

  return `/api/users/${userId}/contacts`
}

export const postApiUserContactCreate = async (userId: string,
    createUserContactRequest: CreateUserContactRequest, options?: RequestInit): Promise<postApiUserContactCreateResponse> => {
  
  return customFetch<postApiUserContactCreateResponse>(getPostApiUserContactCreateUrl(userId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createUserContactRequest,)
  }
);}


export type deleteApiUserContactDeleteResponse204 = {
  data: void
  status: 204
}

export type deleteApiUserContactDeleteResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type deleteApiUserContactDeleteResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type deleteApiUserContactDeleteResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type deleteApiUserContactDeleteResponseSuccess = (deleteApiUserContactDeleteResponse204) & {
  headers: Headers;
};
export type deleteApiUserContactDeleteResponseError = (deleteApiUserContactDeleteResponse401 | deleteApiUserContactDeleteResponse403 | deleteApiUserContactDeleteResponse404) & {
  headers: Headers;
};

export type deleteApiUserContactDeleteResponse = (deleteApiUserContactDeleteResponseSuccess | deleteApiUserContactDeleteResponseError)

export const getDeleteApiUserContactDeleteUrl = (userId: string,
    contactId: string,) => {


  

  return `/api/users/${userId}/contacts/${contactId}`
}

export const deleteApiUserContactDelete = async (userId: string,
    contactId: string, options?: RequestInit): Promise<deleteApiUserContactDeleteResponse> => {
  
  return customFetch<deleteApiUserContactDeleteResponse>(getDeleteApiUserContactDeleteUrl(userId,contactId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


